import React from 'react';

/* eslint-disable max-len */

interface Svg extends React.SVGProps<SVGSVGElement> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export function Svg({
  className = '',
  viewBox = '0 0 24 24',
  children,
  ...props
}: Svg): React.ReactNode {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      height="1em"
      width="1em"
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconDockToLeft(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask id="mask0_599_9869" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_599_9869)">
        <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM16 19H19V5H16V19ZM14 19V5H5V19H14Z" />
      </g>
    </Svg>
  );
}

export function IconDockToRight(props: Partial<Svg>) {
  return (
    <IconDockToLeft {...props} style={{ transform: 'scale(-1, 1)', ...(props?.style || {}) }} />
  );
}

export function IconDangerousOutlined(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5201 4.33184C12.4571 4.33347 12.3943 4.35533 12.3407 4.39763C12.336 4.40232 12.3307 4.40642 12.3254 4.41052C12.3202 4.41462 12.3149 4.41873 12.3102 4.42341L7.06646 9.66381C7.01706 9.74849 6.95677 9.8266 6.88699 9.89607L4.94168 11.839C4.88711 11.8936 4.85698 11.9618 4.85127 12.0314C4.85753 12.1001 4.88759 12.1672 4.94145 12.2211L12.3125 19.5851C12.3711 19.6437 12.4453 19.6741 12.5201 19.6764C12.5949 19.6741 12.6691 19.6437 12.7276 19.5851L20.0987 12.2211C20.1526 12.1672 20.1826 12.1001 20.1889 12.0314C20.1832 11.9618 20.153 11.8936 20.0985 11.839L18.1532 9.89607C18.0834 9.8266 18.0231 9.74849 17.9737 9.66381L12.73 4.42341C12.7253 4.41873 12.72 4.41463 12.7147 4.41053C12.7095 4.40642 12.7042 4.40232 12.6995 4.39763C12.6458 4.35533 12.5831 4.33347 12.5201 4.33184ZM19.596 15.9512C19.6661 15.9069 19.7317 15.8547 19.7914 15.7953L22.6461 12.9429C22.7638 12.8254 22.8571 12.6857 22.9207 12.532C22.9843 12.3783 23.0169 12.2135 23.0167 12.0471C23.0167 12.0406 23.0167 12.0341 23.0165 12.0276C23.0166 12.0217 23.0167 12.0159 23.0167 12.0101C23.0167 11.8437 22.9837 11.6789 22.9198 11.5253C22.8558 11.3716 22.7621 11.2321 22.644 11.1148L17.3945 5.86929C17.3625 5.82687 17.3271 5.78619 17.2883 5.74763L15.6524 4.1117C15.2188 3.6781 14.4735 2.93279 13.4188 1.88045C13.1702 1.63775 12.8448 1.51763 12.5201 1.5198C12.1953 1.51763 11.8699 1.63775 11.6214 1.88045C10.5667 2.93279 9.82137 3.6781 9.38777 4.1117L7.75184 5.74763C7.71307 5.78619 7.67768 5.82687 7.64567 5.86929L2.39613 11.1148C2.27805 11.2321 2.18433 11.3716 2.12037 11.5253C2.05642 11.6789 2.0235 11.8437 2.0235 12.0101C2.0235 12.0159 2.02354 12.0217 2.02362 12.0275C2.02351 12.0341 2.02345 12.0406 2.02344 12.0471C2.02322 12.2135 2.05584 12.3783 2.11944 12.532C2.18303 12.6857 2.27634 12.8254 2.39402 12.9429L5.24871 15.7953C5.30843 15.8547 5.37404 15.9069 5.44417 15.9512L11.6235 22.1258C11.8614 22.3633 12.1838 22.4966 12.52 22.4966C12.52 22.4966 12.52 22.4966 12.5201 22.4966M19.596 15.9512L13.4167 22.1258C13.1978 22.3442 12.9075 22.4746 12.6007 22.4941C12.5739 22.4958 12.5471 22.4966 12.5202 22.4966M12.5201 14.5456C12.5041 14.5459 12.4881 14.5461 12.4721 14.5461C11.8114 14.5461 11.1777 14.2838 10.7105 13.817C10.2432 13.3503 9.98074 12.7171 9.98074 12.057C9.98074 11.3969 10.2432 10.7638 10.7105 10.297C11.1777 9.83019 11.8114 9.56795 12.4721 9.56795C12.4881 9.56795 12.5041 9.5681 12.5201 9.56841C12.536 9.5681 12.552 9.56795 12.568 9.56795C13.2288 9.56795 13.8625 9.83019 14.3297 10.297C14.7969 10.7638 15.0594 11.3969 15.0594 12.057C15.0594 12.7171 14.7969 13.3503 14.3297 13.817C13.8625 14.2838 13.2288 14.5461 12.568 14.5461C12.552 14.5461 12.536 14.5459 12.5201 14.5456Z"
        fill="#FF4D4F"
      />
    </Svg>
  );
}

export default Svg;
